var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkala(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    d: "m192,45.49l0,8.88q-2.06,4.85 -6.32,7.07q-5.84,3.04 -13.23,6c-3.07,1.23 -6.05,-0.09 -6.51,-3.38c-0.46,-3.34 2.27,-4.65 5.03,-5.53a0.4,0.4 0 0 0 0.2,-0.6c-4.27,-6.33 -3.73,-13.47 1.94,-18.06q3.9,-3.15 9.57,-2.3q6.34,0.94 9.32,7.92zm-7.37,4.05a4.19,4.19 0 0 0 -4.19,-4.19a4.19,4.19 0 0 0 -4.19,4.19a4.19,4.19 0 0 0 4.19,4.19a4.19,4.19 0 0 0 4.19,-4.19z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    d: "m136.8,82.19c7.36,4.25 14.68,9.69 18.53,16.67q2.53,4.58 3.12,10.83q1.14,12.16 -4.65,21.67c-3.12,5.12 -8.5,10.03 -14.04,11.38q-5.17,1.25 -11.19,1.3q-14.54,0.12 -53.46,0.11a0.34,0.34 0 0 1 -0.34,-0.34l0.25,-75.6q0,-0.53 0.53,-0.53l23.7,-0.01a0.58,0.57 90 0 1 0.57,0.58l0,49.68q0,0.48 0.49,0.49q17.04,0.04 25.49,0.04q4.49,0 5.98,-0.9c4.63,-2.81 3.42,-8.39 0.84,-12.04c-5.28,-7.46 -15.64,-9.92 -24.42,-9.92q-0.58,0 -0.58,-0.58l0.01,-26.75q0,-0.47 0.43,-0.66l50.6,-21.61q0.67,-0.28 0.67,0.44l-0.01,25.51q0,0.57 -0.52,0.77l-21.97,8.8q-0.7,0.28 -0.03,0.67z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    d: "m190.57,66.83l0,76.69a0.3,0.3 0 0 1 -0.3,0.3l-24.22,0a0.3,0.3 0 0 1 -0.3,-0.3l0,-66.47a0.3,0.3 0 0 1 0.18,-0.28l24.22,-10.21a0.3,0.3 0 0 1 0.42,0.27z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    d: "m36.16,118.26c3.64,-0.95 4.7,-3.5 4.71,-7.3q0,-8.86 0.01,-42.79q0,-0.6 0.58,-0.6l23.57,0q0.58,0 0.58,0.59q0.05,40.31 0.01,46.45c-0.09,12.81 -8.47,23.77 -20.4,27.91q-5.19,1.81 -17.53,1.5q-2.5,-0.06 -17.84,-0.04q-0.54,0 -0.64,-0.53l-4.67,-24.5q-0.11,-0.58 0.47,-0.58l8.51,0a0.33,0.32 82.7 0 0 0.31,-0.4l-12.91,-49.91q-0.11,-0.43 0.34,-0.43l20.79,-0.01q0.63,0 0.78,0.61l12.58,49.59q0.15,0.6 0.75,0.44z",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkala);
export default __webpack_public_path__ + "static/media/Okala.9add17f72a9092208f6416c99a2c6a42.svg";
export { ForwardRef as ReactComponent };